// TODO - replace with ADS QBE Icon

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

const VisaIcon = ({ fontSize }: SvgIconProps) => (
  <SvgIcon fontSize={fontSize}>
    <svg
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Foundation" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Iconography-/-Decorative" transform="translate(-726, -3198)" fillRule="nonzero">
          <g id="Visa" transform="translate(726, 3198)">
            <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="0" y="0" width="48" height="48" />
            <g id="visa-color_large" transform="translate(0, 8)">
              <rect id="card_bg" fill="#2A2A6C" x="0" y="0" width="48" height="32" rx="4" />
              <path
                d="M23.86,11.39 L21.86,20.64 L19.46,20.64 L21.46,11.39 L23.86,11.39 Z M33.92,17.39 L35.18,13.92 L35.91,17.39 L33.92,17.39 Z M36.59,20.67 L38.81,20.67 L36.87,11.42 L34.87,11.42 C34.4299622,11.4240247 34.0355073,11.692254 33.87,12.1 L30.28,20.67 L32.8,20.67 L33.29,19.29 L36.3,19.29 L36.59,20.67 Z M30.35,17.67 C30.36,15.18 27,15 27,14 C27,13.67 27.32,13.32 28,13.23 C28.8092985,13.1499292 29.6251284,13.2916624 30.36,13.64 L30.78,11.64 C30.0636162,11.3713579 29.3050934,11.2325212 28.54,11.23 C26.18,11.23 24.54,12.49 24.54,14.29 C24.54,15.62 25.73,16.36 26.63,16.8 C27.53,17.24 27.88,17.55 27.87,17.95 C27.87,18.57 27.13,18.85 26.44,18.86 C25.5888533,18.8709576 24.7490007,18.6644364 24,18.26 L23.57,20.26 C24.4174838,20.5908441 25.3202552,20.7571441 26.23,20.75 C28.74,20.75 30.39,19.51 30.4,17.59 M20.49,11.3599813 L16.61,20.61 L14,20.61 L12.09,13.22 C12.0564444,12.8682601 11.8397584,12.5603379 11.52,12.41 C10.7692652,12.0517885 9.97633809,11.7897194 9.16,11.63 L9.22,11.3599813 L13.29,11.3599813 C13.8408061,11.3577587 14.3114814,11.7563486 14.4,12.3 L15.4,17.65 L17.89,11.3599813 L20.49,11.3599813 Z"
                id="visa-logo"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default VisaIcon;
